import axios from 'axios';
import { toast } from 'react-toastify';

export const getMySubscriptions = async (queryString = '') => {
    try {
        const response = await axios
            .get(`/api/client/company-subscription?${queryString}`, {
                headers: {
                    "Content-Type": "application/json"
                },
            })
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const validateSubscriptionSerial = async ({ serial }) => {
    try {
        const response = await axios
            .post(`/api/client/company-subscription/serial/validate`, {
                serial
            }, {
                headers: {
                    "Content-Type": "application/json"
                },
            })
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};